import React, { useEffect, useMemo, useState } from "react";
import { Spin, Row, Col, Typography } from "antd";
import { setBreadcrumbs } from "../../redux/slices/breadcrumbsSlice";
import { useDispatch } from "react-redux";
import { ShiftDetails } from "../shiftsPage/shiftDetailPage/components/shiftDetail";
import { useShiftQuery } from "../../hooks/shifts/useShiftQuery";
import { useShiftsQuery } from "../../hooks/shifts/useShiftsQuery";
import { useMobileDetection } from "../../hooks/useMobileDetection";
import { DesktopManifestsTable } from "../shiftsPage/shiftDetailPage/components/desktopManifestsTable";
import { MobileManifestsList } from "../shiftsPage/shiftDetailPage/components/mobileManifestsList";

const breadcrumbs = [{ label: " ", to: "/home" }];

export const HomePage: React.FC = () => {
  const dispatch = useDispatch();
  const isMobile = useMobileDetection();
  const [areDetailsCollapsed, setAreDetailsCollapsed] = useState(false);

  const { data: shiftsData } = useShiftsQuery({ limit: 1, offset: 0 });
  const lastShiftId = shiftsData?.data?.[0]?.id;
  const { data: shiftData, isLoading } = useShiftQuery(lastShiftId || "");


  useEffect(() => {
    dispatch(setBreadcrumbs(breadcrumbs));
  }, [dispatch]);

  const manifestsTable = useMemo(() => {
    if (!shiftData?.manifests?.length) return null;

    return isMobile ? (
      <MobileManifestsList
        data={shiftData.manifests}
        isLoading={false}
        shiftId={lastShiftId || ""}
      />
    ) : (
      <DesktopManifestsTable
        data={shiftData.manifests}
        rowKey="id"
        shiftId={lastShiftId || ""}
      />
    );
  }, [isMobile, shiftData?.manifests, lastShiftId]);

  if (isLoading) return <Spin size="large" />;

  return (
    <Row justify="center">
      <Col xs={24} sm={24} md={22} lg={20} xl={18}>
        {shiftData ? (
          <>
            <ShiftDetails
              shift={shiftData}
              showFullDetails={!areDetailsCollapsed}
              detailsTitle="Текущий рейс"
              onDetailsTitleClick={() =>
                setAreDetailsCollapsed(!areDetailsCollapsed)
              }
              shiftId={lastShiftId || ""}
            >
              {shiftData.manifests?.length ? <div>{manifestsTable}</div> : null}
            </ShiftDetails>
          </>
        ) : (
          <div
            style={{
              textAlign: "center",
              //  marginTop: "20vh"
            }}
          >
            <Typography.Title level={3}>Нет активных рейсов</Typography.Title>
            <Typography.Paragraph>
              На данный момент нет доступных рейсов для отображения
            </Typography.Paragraph>
          </div>
        )}
      </Col>
    </Row>
  );
};
